/**
 * Layer Preferences API Service
 *
 * Persists user layer visibility preferences per workspace.
 * Follows layersService pattern: plain exported object with typed apiClient calls.
 */

import { apiClient } from './apiClient';
import { API_ENDPOINTS } from '@/constants/api';
import type { LayerVisibility, ArtifactVisibility } from '@/types/layers';

export interface LayerPreferencesData {
  standardLayers: Partial<LayerVisibility>;
  customLayers: Record<string, boolean>;
  artifactLayers?: Partial<ArtifactVisibility>;
}

interface GetLayerPreferencesResponse {
  preferences: string | null;
}

interface UpdateLayerPreferencesResponse {
  preferences: string;
}

export const layerPreferencesService = {
  /** GET /api/v1/layers/preferences - get saved layer visibility preferences */
  get: () =>
    apiClient.get<GetLayerPreferencesResponse>(
      API_ENDPOINTS.LAYERS.PREFERENCES
    ),

  /** PUT /api/v1/layers/preferences - save layer visibility preferences */
  update: (preferences: LayerPreferencesData) =>
    apiClient.put<UpdateLayerPreferencesResponse>(
      API_ENDPOINTS.LAYERS.PREFERENCES,
      {
        preferences: JSON.stringify(preferences),
      }
    ),
};
